import alt from '../components/alt';

class LocalesActions {
  setCurrentLocale(locale) {
    return locale;
  }
}

export default alt.createActions(LocalesActions);
